import { render, staticRenderFns } from "./AscChips.vue?vue&type=template&id=31ef2f5f&"
import script from "./AscChips.vue?vue&type=script&lang=js&"
export * from "./AscChips.vue?vue&type=script&lang=js&"
import style0 from "./AscChips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports